import { DigitalDataOrigin } from './digital-data-types'

type ProductDetails = {
  availability: string
  item_list_name: Array<DigitalDataOrigin>
  item_list_page: string[]
  category_path: string
  has_image: boolean
  product_life_cycle: string
  weighted_average_score: string
  has_variants: boolean
  label?: string[] | null
}
type MissingCartDetails = Record<string, ProductDetails | undefined>
type LocalStorageKey = 'missingCartDetails'

type RemoveAllAction = {
  action: 'REMOVE_ALL'
}

type RemoveAction = {
  action: 'REMOVE'
  productErp: string
  newQuantity: number
}

type AddAction = {
  action: 'ADD'
  product: any
  digitalDataOrigin?: DigitalDataOrigin
  label?: string[] | null
  newQuantity?: number
}

type StoreCartDetails = AddAction | RemoveAction | RemoveAllAction

export function storeCartDetails(data: StoreCartDetails): void {
  const { action } = data

  if (action === 'ADD') {
    addProductDetails(data.product, data.digitalDataOrigin, data.label)
  }

  if (action === 'REMOVE') {
    removeProductDetail(data.productErp, data.newQuantity)
  }

  if (action === 'REMOVE_ALL') {
    removeItem('missingCartDetails')
  }
}

export function getMissingCartDetails(): MissingCartDetails {
  const localStorageData = localStorage.getItem('missingCartDetails')
  const missingCartDetails = localStorageData == null ? {} : JSON.parse(localStorageData)

  return missingCartDetails as MissingCartDetails
}

function addProductDetails(
  product: any,
  digitalDataOrigin?: DigitalDataOrigin,
  label?: string[] | null
) {
  if (product == null) return

  const missingCartDetails = getMissingCartDetails()
  const productErp = product.productErpIdentifier
  const productDetails = missingCartDetails[productErp]

  if (productDetails == null) {
    missingCartDetails[productErp] = {
      availability:
        product.availability?.availabilityDetails?.key || product.availability?.availabilityStatus,
      item_list_name: [digitalDataOrigin ?? 'productPage'],
      item_list_page: [getItemListPage(window.location.href)],
      category_path: product.category_path,
      has_image: product.primaryImageId ? true : false,
      product_life_cycle: product?.availability?.productLifeCycleState || 'NONE',
      weighted_average_score: product.reviewScore?.toString(),
      has_variants: false,
      label,
    }
  } else {
    missingCartDetails[productErp]?.item_list_name.push(digitalDataOrigin ?? 'productPage')
    missingCartDetails[productErp]?.item_list_page.push(getItemListPage(window.location.href))
  }

  setItem('missingCartDetails', missingCartDetails)
}

function removeProductDetail(productErp: string, newQuantity: number) {
  const missingCartDetails = getMissingCartDetails()
  const productDetails = missingCartDetails[productErp]

  if (productDetails == null) return

  const listLength: number = missingCartDetails[productErp]?.item_list_name.length || 0

  if (newQuantity != null && newQuantity > 0 && newQuantity < listLength) {
    missingCartDetails[productErp]?.item_list_name.splice(newQuantity, listLength - newQuantity)
    missingCartDetails[productErp]?.item_list_page.splice(newQuantity, listLength - newQuantity)
  }

  if (newQuantity === 0) {
    missingCartDetails[productErp] = undefined
  }

  setItem('missingCartDetails', missingCartDetails)
}

function setItem(key: LocalStorageKey, data: unknown): void {
  localStorage.setItem(key, JSON.stringify(data))
}

function removeItem(key: LocalStorageKey): void {
  localStorage.removeItem(key)
}

function getItemListPage(locationRef: string): string {
  const path = new URL(locationRef).pathname
  const itemListPage = path.substring(path.lastIndexOf('/') + 1)

  return itemListPage === '' ? '/' : itemListPage
}
